import { isValidDate } from '@/modules/results/helpers';

interface MatchListCardWithGamesProps {
  start1?: string;
  end1?: string;
  start2?: string;
  end2?: string;
  streak1?: number;
  streak2?: number;
  text1?: string;
  text2?: string;
  games1?: string[];
  games2?: string[];
}

function MatchListCardWithGames({
  start1 = '',
  end1 = '',
  start2 = '',
  end2 = '',
  streak1 = 0,
  streak2 = 0,
  text1 = '',
  text2 = '',
  games1 = [],
  games2 = [],
}: MatchListCardWithGamesProps) {
  const isValidString = (str: string) => {
    return (
      typeof str === 'string' &&
      str.trim() !== '' &&
      str !== 'Invalid date' &&
      str !== 'Invalid date CDT'
    );
  };

  const isValidStart1 = isValidDate(start1) || isValidString(start1);
  const isValidEnd1 = isValidDate(end1) || isValidString(end1);
  const isValidStart2 = isValidDate(start2) || isValidString(start2);
  const isValidEnd2 = isValidDate(end2) || isValidString(end2);

  return (
    <div className='flex min-h-[110px] flex-wrap border-b py-2 sm:flex-nowrap'>
      <div className='order-2 flex w-1/2 flex-col items-center justify-center p-2 sm:order-1 sm:w-1/3 sm:p-0 '>
        <span className='font-bold'>{streak1}</span>
        <div className='text-xs'>
          <ul className='flex justify-center gap-2'>
            {games1?.map((item, index, array) => (
              <li key={`${item}-team-one-${index}`}>
                {item}
                {index === array.length - 1 ? '' : ' - '}
              </li>
            ))}
          </ul>
          {isValidStart1 && isValidEnd1 ? (
            <span>
              {start1} - {end1}
            </span>
          ) : null}
        </div>
      </div>
      <div className='order-1 flex w-full flex-col items-center justify-center text-center sm:order-2 sm:w-1/3'>
        <h5 className='font-bold'>{text1}</h5>
        <h6 className='text-xs'>{text2}</h6>
      </div>
      <div className='order-2 flex w-1/2 flex-col items-center justify-center px-3 sm:order-3 sm:w-1/3 sm:p-0 '>
        <span className='font-bold'>{streak2}</span>
        <div className='text-xs'>
          <ul className='flex justify-center gap-2'>
            {games2?.map((item, index, array) => (
              <div key={`${item}-team-two-${index}`}>
                {item}
                {index === array.length - 1 ? '' : ' - '}
              </div>
            ))}
          </ul>
          {isValidStart2 && isValidEnd2 ? (
            <span>
              {start2} - {end2}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default MatchListCardWithGames;
